import { render, staticRenderFns } from "./mumsnetP1.vue?vue&type=template&id=2d97e933&scoped=true&"
import script from "./mumsnetP1.vue?vue&type=script&lang=js&"
export * from "./mumsnetP1.vue?vue&type=script&lang=js&"
import style0 from "./mumsnetP1.vue?vue&type=style&index=0&id=2d97e933&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d97e933",
  null
  
)

export default component.exports